import React from 'react';
import { useRecordContext } from 'react-admin';
import { Chip, Typography } from '@mui/material';
import { Client } from '../types';

// Sentinel value stored in clients.sin when the customer marked their SIN as
// unknown in aura-app. Kept in sync with aura-app's onboarding transforms and
// ClientEditBase's SIN_UNKNOWN constant.
export const SIN_UNKNOWN = 'UNKNOWN';

/**
 * Read-only decorator for the SIN column. Renders a clear "Unknown" chip when
 * the customer explicitly marked their SIN as unknown (sentinel value), instead
 * of showing the raw `UNKNOWN` text or a misleading blank.
 */
const SinField = (props: { source?: string; label?: string }) => {
  const record = useRecordContext<Client>();
  const value = record?.sin;

  if (value === SIN_UNKNOWN) {
    return <Chip label="Unknown" size="small" variant="outlined" />;
  }

  return <Typography variant="body2">{value || ''}</Typography>;
};

export default SinField;
